/**
 * Header Constants
 * Channel and package type display configurations.
 */

import type { CorrespondenceChannel } from '@/services/api/correspondenceService';

import type { CorrespondencePackageType } from '../types';
// Re-export status display from the canonical source
export {
  STATUS_DISPLAY,
  type StatusConfig as StatusDisplayConfig,
} from '../utils/status';

// ============================================================================
// Channel Configuration
// ============================================================================

export interface ChannelDisplayConfig {
  label: string;
  shortLabel: string;
  icon: string; // Emoji for minimal display
  description: string;
}

export const CHANNEL_CONFIG: Record<
  CorrespondenceChannel,
  ChannelDisplayConfig
> = {
  fax: {
    label: 'Fax',
    shortLabel: 'Fax',
    icon: '📠',
    description: 'Sending via fax',
  },
  email: {
    label: 'Email',
    shortLabel: 'Email',
    icon: '✉️',
    description: 'Sending via email',
  },
  mailed_letter: {
    label: 'Mail',
    shortLabel: 'Mail',
    icon: '📬',
    description: 'Sending via postal mail',
  },
  mailed_cheque: {
    label: 'Cheque',
    shortLabel: 'Cheque',
    icon: '💵',
    description: 'Sending a cheque via mail',
  },
};

// ============================================================================
// Package Type Configuration
// ============================================================================

export interface PackageTypeDisplayConfig {
  label: string;
  shortLabel: string;
  description: string;
}

export const PACKAGE_TYPE_DISPLAY: Record<
  CorrespondencePackageType,
  PackageTypeDisplayConfig
> = {
  hipaa_authorization: {
    label: 'HIPAA Authorization',
    shortLabel: 'HIPAA',
    description: 'Medical records authorization request',
  },
  foia_request: {
    label: 'FOIA Request',
    shortLabel: 'FOIA',
    description: 'Freedom of Information Act request',
  },
  lien_notice: {
    label: 'Lien Notice',
    shortLabel: 'Lien',
    description: 'Notice of lien to insurance carrier',
  },
  demand_package: {
    label: 'Demand Letter',
    shortLabel: 'Demand',
    description: 'Settlement demand letter',
  },
  follow_up: {
    label: 'Follow Up',
    shortLabel: 'Follow Up',
    description: 'Follow-up correspondence',
  },
  subpoena: {
    label: 'Subpoena',
    shortLabel: 'Subpoena',
    description: 'Legal subpoena document',
  },
  premises_lor: {
    label: 'Premises LOR',
    shortLabel: 'Premises LOR',
    description: 'Certified-mail premises letter of representation',
  },
  custom: {
    label: 'Custom',
    shortLabel: 'Custom',
    description: 'Custom correspondence',
  },
};
